import { render, staticRenderFns } from "./conducting_resin.vue?vue&type=template&id=084a4caa&scoped=true"
import script from "./conducting_resin.vue?vue&type=script&lang=js"
export * from "./conducting_resin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084a4caa",
  null
  
)

export default component.exports